module.exports = __webpack_public_path__ + "assets/img/travel-day22.ace83bc2.png";